var _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayerIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 161 112",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "player-illustration"
  }, "Illustration einer Musikkartei") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "player-illustration"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "slider"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.119731,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.926,
    y: 97.432,
    width: 135.388,
    height: 4.595
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.716547,0,0,0.716547,57.304,29.9942)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.679,
    cy: 97.321,
    r: 9.003,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "5.58px"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "carousel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02867,0,0,1,-3.32343,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.012,3.103L42.962,3.103L42.962,82.331L120.012,82.331L120.012,3.103ZM116.124,7.103L116.124,78.331C116.124,78.331 46.85,78.331 46.85,78.331C46.85,78.331 46.85,7.103 46.85,7.103L116.124,7.103Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-0.296236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.249,73.888L120.13,73.888L120.13,77.888L136.249,77.888L136.249,8.138L120.13,8.138L120.13,12.138L132.249,12.138L132.249,73.888Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-0.0591703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.939,65.349L161,65.349L161,20.203L149.939,20.203L149.939,24.203L157,24.203L157,61.349L149.939,61.349L149.939,65.349Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-0.200567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.939,71.571L149.939,14.264L136.249,14.264L136.249,18.264L145.939,18.264L145.939,67.571L136.249,67.571L136.249,71.571L149.939,71.571Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.22465e-16,1.22465e-16,-1,161,85.73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.249,73.888L120.13,73.888L120.13,77.888L136.249,77.888L136.249,8.138L120.13,8.138L120.13,12.138L132.249,12.138L132.249,73.888Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.22465e-16,1.22465e-16,-1,161,85.4929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.939,65.349L161,65.349L161,20.203L149.939,20.203L149.939,24.203L157,24.203L157,61.349L149.939,61.349L149.939,65.349Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.22465e-16,1.22465e-16,-1,161,85.6343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.939,71.571L149.939,14.264L136.249,14.264L136.249,18.264L145.939,18.264L145.939,67.571L136.249,67.571L136.249,71.571L149.939,71.571Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "note"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15943e-17,-0.18935,1,6.12323e-17,-25.3629,54.9048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.314,97.432L12.926,97.432L22.748,102.027L148.314,102.027L148.314,97.432Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.36898e-17,-0.223572,1,6.12323e-17,-1.6789,53.2159)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.926,
    y: 97.432,
    width: 135.388,
    height: 4.595
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.208877,-0.0728202,0.329195,0.944262,37.2948,-64.2754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.314,97.432L12.926,97.432L6.468,101.529L141.856,101.529L148.314,97.432Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.904664,-0.451393,0.353784,0.709041,-24.149,22.6765)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.679,
    cy: 97.321,
    r: 9.003,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "4.4px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.904664,-0.451393,0.353784,0.709041,-47.833,23.03)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.679,
    cy: 97.321,
    r: 9.003,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "4.4px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerIllustration);
export default __webpack_public_path__ + "static/media/player_illustration.c1db9197.svg";
export { ForwardRef as ReactComponent };